function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "b10e4f15-13d1-48c9-8c73-420c8164b028",
  x: 0,
  y: 1,
  width: 14.73,
  height: 14.16,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -0.84)"
}, /*#__PURE__*/React.createElement("g", {
  id: "f1da6a17-4d9c-4f14-a02e-9c8394c274f9",
  "data-name": "mask-2"
}, /*#__PURE__*/React.createElement("rect", {
  id: "abca8449-041d-4a21-8b33-b3a35f15c99e",
  "data-name": "path-1",
  x: 2.69,
  y: 4,
  width: 9.75,
  height: 8.81,
  transform: "translate(-3.73 7.82) rotate(-45)",
  fill: "#fff"
})))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "b3ca5f97-b356-42ac-a66d-fc76caeff15e",
  "data-name": "pixel-this-clothing-/-icons-/-bucket---dark"
}, /*#__PURE__*/React.createElement("g", {
  id: "b1181cde-aa62-47bf-b358-dee368c32474",
  "data-name": "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "b46245f6-66bd-433f-b0a0-8467e0afdbfd",
  "data-name": "Rectangle-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "acc4a687-1b91-4355-904f-cc5573ede80c",
  "data-name": "Rectangle"
}, /*#__PURE__*/React.createElement("rect", {
  id: "a2dd749a-51f5-480d-9457-36c82e4d5099",
  "data-name": "path-1",
  x: 2.69,
  y: 4,
  width: 9.75,
  height: 8.81,
  transform: "translate(-3.73 6.97) rotate(-45)",
  fill: "none",
  stroke: "#363636",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b10e4f15-13d1-48c9-8c73-420c8164b028)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "f2474d3b-cfb6-4683-926c-7be8e5e59f07",
  "data-name": "Rectangle",
  points: "0 7.16 14.73 7.16 14.73 15.16 0 15.16 0 7.16",
  fill: "#363636",
  fillRule: "evenodd"
}))), /*#__PURE__*/React.createElement("line", {
  id: "f5775295-3973-4fb6-8dbc-ea1b8893770b",
  "data-name": "Path-24",
  x1: 3.31,
  y1: 1.34,
  x2: 7.77,
  y2: 5.8,
  fill: "none",
  stroke: "#363636",
  strokeLinecap: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("path", {
  id: "b831839f-e7d6-440f-b81e-b295e083b6fd",
  "data-name": "Oval",
  d: "M14.42,16a1.45,1.45,0,0,0,1.46-1.45c0-.54-.49-1.31-1.46-2.32-1,1-1.45,1.78-1.45,2.32A1.45,1.45,0,0,0,14.42,16Z",
  transform: "translate(0 -0.84)",
  fill: "#363636",
  fillRule: "evenodd"
}));

function SvgBucket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "paint-bucket",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 15.88 15.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBucket);
export default __webpack_public_path__ + "static/media/bucket.7e739ea6.svg";
export { ForwardRef as ReactComponent };